import { Model } from '@vuex-orm/core';
import { uuidv4 } from '../../utils/helpers';

export class TreatmentCategory extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'treatment_categories';

  static fields() {
    return {
      id: this.attr(() => uuidv4()),
      name: this.attr(null),
      updated_at: this.attr(null),
      created_at: this.attr(null),
    };
  }
}

export default TreatmentCategory;
